export const SUPPLIER_DATA_SHARE_DATA='SUPPLIER_DATA_SHARE_DATA';
export const SUPPLIER_DATA_SHARE_UUID='SUPPLIER_DATA_SHARE_UUID';
export const SUPPLIER_DATA_SHARE_REGISTER='SUPPLIER_DATA_SHARE_REGISTER';